import { useQuery } from '@apollo/client/react'
import { GET_GBP_LOCATIONS } from '@/lib/operations/dashboard'
import type { GbpLocation } from '@/lib/types'

export function useGbpLocations(clientId: string | null) {
  const { data, loading, error } = useQuery<{ gbpLocations: GbpLocation[] }>(GET_GBP_LOCATIONS, {
    variables: { clientId },
    skip: !clientId,
  })
  return { locations: data?.gbpLocations ?? [], loading, error }
}
